module.exports = {
    label: {
        all: '全部尺寸',
        search: '搜索',
        updateAll: '全部更新',
        bindUpdateAll: '全部绑定',
        rebind: '未绑定重绑',
        upgradeAll: '全部升级',
        import: '导 入',
        // bindUpdatePart:'绑 定',
        // rouseAll:'唤 醒',
        // deleteAll:'删 除',
        queryText: '请选择尺寸搜索',
        submiting: '提交中...',
        operation: {
            operation: '操 作',
            more: '更多',
            bindUpdatePart: '绑定',
            rouseAll: '唤醒',
            deleteAll: '删除',
            downloadLabel: '下载标签表',
            downloadBind: '下载绑定表',
            batchUpdate: '更新',
            reset: '复位',
            upgradeESL: '升级',
            importBinding: '导入绑定表'
        },
        table: { //标签信息
            index: '序号',
            mac: 'MAC地址',
            screenSize: '尺寸(")',
            battery: '电量(%)',
            lastupdate: '最后广播时间',
            updateTime: '最后更新时间',
            gatewayMac: '绑定网关',
            onlineStatus: '在线状态',
            operation: '操作',
            bindUpdate: '绑定',
            rouse: '唤醒',
            delete: '删除',
            online: '在线',
            offline: '离线'
        },
        table2: {
            operation: '操作',
            update: '修改',
            delete: '删除'
        },
        equipmentInfo: '设备信息',
        devices: { //设备信息
            Manufacturer: '制造商：',
            battery: '电量：',
            temperature: '温度：',
            runningTime: '运行时间：',
            rssi: '校准距离：',
            firmwareVersion: '固件版本：',
            hardwareVersion: '硬件版本：',
            screenInfo: '屏幕信息：',
            chipInfo: '芯片信息：',
            // screenInfos:[
            // {
            //     key:'0001',
            //     value:'1.54"(152*152) 黑白',
            //     size:'1.54',
            //     rotate:'向左旋转90°'
            // },{
            //     key:'0002',
            //     value:'2.13"(212*104) 黑白',
            //     size:'2.13',
            //     rotate:''
            // },{
            //     key:'0003',
            //     value:'2.13"(250*122) 黑白',
            //     size:'2.13',
            //     rotate:''
            // },{
            //     key:'0004',
            //     value:'2.9"(296*128) 黑白',
            //     size:'2.9',
            //     rotate:''
            // },{
            //     key:'0005',
            //     value:'4.2"(300*400) 黑白',
            //     size:'4.2',
            //     rotate:'向左旋转90°'
            // }],
            hardwareInfos: [{
                key: '0001',
                value: 'MO95SF6_V1.0'
            }, {
                key: '0002',
                value: 'MS107F6_V1.0'
            }, {
                key: '0003',
                value: 'MS105F6_V1.4'
            }, {
                key: '0004',
                value: 'MS106F6_V1.0'
            }, {
                key: '0005',
                value: 'MS116F6_V1.0'
            }, {
                key: '0006',
                value: 'MS117F6_V1.0'
            },{
                key: '0007',
                value: 'MS127F6_V1.0'
            },{
                key:"0008",
                value:"MS128F6_V1.0"
            },{
                key:"0009",
                value:"MS134F6_V1.0"
            },{
                key:"000A",
                value:"MS132F6_V1.0"
            }],
            chipInfos: [{
                key: '01',
                value: 'Nordic Semi, nRF52810'
            }]

            // mac:'Mac地址：',
            // type:'型号：',
            // screenSize:'屏幕尺寸：',
            // battery:'电量：',
            // software:'软件版本：',
            // protocolStack:'协议栈版本：',
            // manufacturer:'制造商：',
            // hardware:'硬件版本：',
            // heartbeat:'广播时长：'
            // upgrade:'升 级',
        },
        isHaveGateway: '请先添加网关',
        preview: '显示预览',
        bindProducts: '绑定商品',
        cancel: '取 消',
        sure: '确 定',
        hint: '提 示',
        labelLight: { //标签灯
            green1: '/static/images/label_green_1.png',
            green2: '/static/images/label_green_2.png',
            blue1: '/static/images/label_blue_1.png',
            blue2: '/static/images/label_blue_2.png',
            red1: '/static/images/label_red_1.png',
            red2: '/static/images/label_red_2.png'
        },
        labelLightMsg: { //标签灯提示信息
            green: '亮绿灯',
            red: '亮红灯',
            blue: '亮蓝灯',
            success: '标签 {mac}：亮{color}灯指令发送成功',
            fail: '标签 {mac}：亮{color}灯指令发送失败',
            unbind: '标签 {mac}：当前标签未绑定网关',
            noLabel: '标签 {mac}：当前标签不存在',
            chooseLabel: '请选择要亮灯的标签',
            color: [{
                key: '1',
                value: '蓝'
            }, {
                key: '2',
                value: '绿'
            }, {
                key: '3',
                value: '红'
            }]
        },
        bindRelation: { //绑定商品-新增和修改绑定关系
            title: '绑定',
            title2: '修改',
            add: '新增模板',
            del: '删除',
            save: '保存',
            saving: '保存中...',
            id: 'ID：',
            templates: '模板：',
            placeholder1: '请输入商品的ID',
            templateType: {
                common: '常用',
                promotion: '促销',
                activity: '活动'
            },
            effect: {
                valid: '有效',
                invalid: '无效'
            },
            limitMsg: '绑定的模板已达到7个上限,无法继续添加',
            getTemplateFail: '获取该尺寸所有模板失败！请重新操作',
            noTemplate: '模板不存在',
            noLabel: '标签不存在',
            noProduct: '没有此商品信息,请先导入或添加',
            success: '绑定成功',
            modifySuccess: '修改绑定成功',
            fail: '绑定失败',
            delFail: '删除失败',
            noBind: '没有绑定网关',
            tip: {
                product: 'ID',
                label: '标签',
                template: '模板名'
            },
            validate: {
                id: '请输入商品的ID',
                isNum: "请输入字母或数字",
                noTemplates: '请选择模板',
                noTemplatesData: '该标签不存在对应尺寸的模板',
                bindGateway: '标签请先绑定网关',
                noPermission: '您没有查看模板权限'
            }

        },
        delBindRelation: { //绑定商品-删除绑定关系
            dialogMsg: '确定删除标签{mac}和商品{id}的绑定关系吗?',
            dialogTitle: '删 除',
            success: '删除标签和商品的绑定关系成功！',
            fail: '删除标签和商品的绑定关系失败！',
            noBindRelation: '绑定关系已删除，无须再次操作！'
        },
        dialogLabelUpdateAll: { //标签管理-更新当前门店所有标签弹框
            dialogTitle: '更 新',
            dialogMsg: '确定更新当前门店所有标签吗?',
            success: '全部更新指令发送成功,请稍后刷新页面获取最新数据！',
            fail: '全部更新指令发送失败！',
            hint: '当前正在进行标签更新，请等待标签更新结束后再次操作！',
            input: '请先导入标签！'
        },
        dialogBindUpdateAll: { //标签管理-绑定当前门店所有未绑定标签弹框
            dialogTitle: '绑 定',
            dialogMsg: '确定把当前门店所有标签绑定网关吗?',
            success: '全部绑定指令发送成功,请稍后刷新页面获取最新状态！',
            fail: '全部绑定指令发送失败！',
            input: '请先导入标签！'
        },
        dialogRebind: { //标签管理-绑定当前门店所有未绑定标签弹框
            dialogTitle: '绑 定',
            gateway: '网关 ',
            dialogMsg: '确定重新绑定当前门店所有未绑定的标签吗?',
            success: '给网关发送重绑指令成功',
            fail: '给网关发送重绑指令失败！',
            isSend: '网关工作繁忙中，请等待网关处理结束，再重新发送指令',
            isHaveGateway: '请先添加网关'
        },
        dialogUpgradeAll: { //标签管理-批量升级
            dialogTitle: '升 级',
            input: '请先导入标签！',
            versionInfoFail: '查询标签固件版本号失败',
            upgradeSuccess: '升级指令发送成功，标签固件升级中,请保持网关在线...',
            upgradeFail: '升级指令发送失败',
            versionNotEmpty: '固件版本不能为空',
            macNotEmpty: 'mac地址不能为空',
            version: '固件版本',
            mac: 'Mac地址',
            tip: '请选择',
            hint: '请先选择要升级的标签！',
            fail1: '标签没有与网关绑定！',
            fail2: '标签不存在！',
            label: '标签 ',
            noPermission: '升级失败，没有权限！'
        },
        dialogUpgradeOne: {
            upgradeESL: '升 级',
            dialogTitle: '升 级',
            tip: '此功能将升级当前标签固件版本',
            upgradeSuccess: '升级指令发送成功，标签固件升级中,请保持网关在线...',
            upgradeFail: '升级指令发送失败',
            notExist: '标签固件升级包不存在',
            notBind: '当前标签没有绑定网关',
            notEsl: '没有此标签',
            noPermission: '升级失败，没有权限！',
            chooseLabel: '请选择要升级的标签',
            noType: '标签没有对应类型的固件升级包'
        },
        dialogBindUpdatePart: { //标签管理-绑定标签弹框
            dialogTitle: '绑 定',
            dialogMsg: '确定绑定选中的标签吗?',
            hint: '请先选择要绑定网关的标签！',
            success: '批量绑定指令发送成功,请稍后刷新页面获取最新数据！',
            fail: '批量绑定指令发送失败！'
        },
        dialogLabelUpdatePart: { //标签管理-更新选中标签弹框
            dialogTitle: '更 新',
            dialogMsg: '确定更新选中的标签吗?',
            hint: '请先选择要更新的标签！',
            success: '批量更新指令发送成功,请稍后刷新页面获取最新数据！',
            fail: '批量更新指令发送失败！',
            fail1: '标签没有与网关绑定',
            fail2: '没有导入对应的标签！',
            fail3: '标签绑定的模板为空模板！',
            fail4: '标签没有绑定商品！',
            fail5: '标签绑定的模板不存在！',
            fail6: '标签绑定的商品不存在！',
            label: '标签 '
        },
        dialogReset: { //标签管理-复位标签弹框
            dialogTitle: '复 位',
            dialogMsg: '确定复位选中的标签吗?',
            hint: '请先选择要复位的标签！',
            success: '批量复位指令发送成功,请稍后刷新页面获取最新数据！',
            fail: '批量复位指令发送失败！',
            fail1: '标签没有与网关绑定！',
            fail2: '标签不存在！',
            label: '标签 '
        },
        dialogRouseAll: { //标签管理-唤醒选中标签弹框
            dialogTitle: '唤 醒',
            dialogMsg: '确定唤醒选中的标签吗?',
            hint: '请先选择要唤醒的标签！',
            success: '批量唤醒指令发送成功,请稍后刷新页面获取最新状态！',
            fail: '批量唤醒指令发送失败！'
        },
        dialogDelAll: { //标签管理-删除选中标签弹框
            dialogTitle: '删 除',
            dialogMsg: '确定删除选中的标签吗?',
            hint: '请先选择要删除的标签！',
            success: '批量删除标签成功！',
            fail: '批量删除标签失败！',
            noPermission: '批量删除标签失败,没有权限！'
        },
        dialogBindUpdate: { //标签管理-绑定弹框
            dialogTitle: '绑 定',
            dialogMsg: '确定绑定mac地址为{mac}的标签吗?',
            success: '绑定指令发送成功,请稍后刷新页面获取最新状态！',
            // noDevice:'没有网关检测到此设备！',
            fail: '绑定指令发送失败！'
        },
        dialogRouse: { //标签管理-唤醒弹框
            dialogTitle: '唤 醒',
            dialogMsg: '确定唤醒mac地址为{mac}的标签吗?',
            success: '唤醒指令发送成功,请稍后刷新页面获取最新状态',
            unbind: '标签没有绑定网关！',
            fail: '唤醒指令发送失败！'
        },
        dialogDel: { //标签管理-删除弹框
            dialogTitle: '删 除',
            dialogMsg: '确定删除mac地址为{mac}的标签吗?',
            success: '删除标签成功！',
            fail: '删除标签失败！',
            noDevice: '不存在此标签设备！',
            noPermission: '删除标签失败，没有权限'
        },
        // dialogUpgrade:{ //标签管理-升级弹框
        //     dialogTitle:'升 级',
        //     dialogMsg:'确定升级当前设备吗?',
        //     chooseLabel:'请选择标签！'
        // },
        formatTime: { //秒 转 (天 时 分)
            day: '天',
            hour: '时',
            minute: '分',
        },
        getTemplateAndPro: { //根据标签获取模板和商品数据
            unbind: '该标签未绑定商品',
            fail: '获取标签模板和商品数据失败！',
            unbindTp: '该标签绑定的模板不存在！'
        },
        queryLabel: { //查询标签
            fail: '查询标签失败！'
        },
        getPrefix: {
            fail: '获取标签前缀失败'
        },
        permission: { //数据库数据，判断权限，不可改动
            delLabel: '删除标签',
            addLabel: '新增标签'
        },
        upload: {
            success: '导入标签完成,成功{success}个,失败{fail}个！',
            fail: '导入标签失败！',
            msg: '上传文件只能是Excel表格',
            noPermission: '导入标签失败，没有权限！',
            downloadText: '下载导入处理结果文件'
        },
        uploadBindRelation: {
            success: '导入完成,成功{success}个,失败{fail}个！',
            fail: '导入失败！',
            msg: '上传文件只能是Excel表格'
        },
        labelFilter: {
            label: '电子标签',
            deviceState: '设备状态',
            allDevice: '全部设备',
            labelStatus: {
                online: '在线',
                offline: '离线',
                bindGateway: '已绑定网关',
                unbindGateway: '未绑定网关',
                lowPower: '低电量'
            }
        }

    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/label.js